const ArrowDownLoginIcon = () => {
  return (
    <svg
      fill="#000000"
      height="10"
      width="10"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 386.257 386.257"
    >
      <polygon points="0,96.879 193.129,289.379 386.257,96.879 " />
    </svg>
  );
};

export default ArrowDownLoginIcon;
